import flowioast from "src/utils/flowioast";
import * as requests from "../../../requests/login/requestCreators";
import { EwaThunk } from "../../types";
import {
  errorLogin,
  requestLogin,
  successLogin,
} from "../actionCreators/authentication/activeDirectoryLoginCreator";

const requestActiveDirectoryLogin =
  (login: string, password: string): EwaThunk =>
  async (dispatch, getState) => {
    const localState = getState().login;

    if (localState.isFetching) {
      return;
    }
    dispatch(requestLogin());
    try {
      requests
        .activeDirectoryLogin({
          login,
          password,
        })
        .then(async (response) => {
          const userDto = response.data;
          const { data: isUserAdmin } = await requests.isUserAdmin();
          dispatch(successLogin(userDto, isUserAdmin));
        })
        .catch((error) => {
          dispatch(errorLogin(error.response.data));
        });
    } catch (e) {
      flowioast.error.fromIntlId("login.active_directory.error", e);
    }
  };

export default requestActiveDirectoryLogin;
